import React from "react";
import "../DashboardUnique.css";
import { toIndianCurrencyHeader } from "../../../MethodMaster/JSXComponentMothod";

export default function VillageDetailHeader({ village, handleNavigateToMainTab, tab }) {
  console.log("sdfjnsdfsdf", tab);
  return (
    <div className={"govdash-villageDetailHeader"}>
      <div onClick={handleNavigateToMainTab} className={"govdash-detailIconWrapper cursor-pointer"}>
        <i className="govdash-VillageHeaderCard-icon  fas fa-house-user"></i>
      </div>
      <div className={"govdash-detailInfo"}>
        <h2 className={"govdash-detailName"}>{village.VillageNameEnglish}</h2>
        <div className={"govdash-detailStats"}>
          <div className={"govdash-statItem"}>
            <span className={"govdash-statLabel"}>Total Labharthi</span>
            <span className={"govdash-statValue"}>{village.BeneficialCount.toLocaleString()}</span>
          </div>
          {tab === "village" && (
            <div className={"govdash-statItem"}>
              <span className={"govdash-statLabel"}>Total Labharthi Labh</span>
              <span className={"govdash-statValue"}>{village?.TotalLabharthiLabh?.toLocaleString()}</span>
            </div>
          )}
          {!!Number(village?.TotalAmount || 0) && (
            <div className={"govdash-statItem"}>
              <span className={"govdash-statLabel"}>Amount Disbursed</span>
              {/* <span className={"govdash-statValue"}>₹{village?.TotalAmount?.toLocaleString()}</span> */}
              <span className={"govdash-statValue"}>
                ₹{village?.TotalAmount?.toLocaleString()}
                {toIndianCurrencyHeader(village?.TotalAmount)}
              </span>
            </div>
          )}
          <div className={"govdash-statItem"}>
            <span className={"govdash-statLabel"}>Total Voters</span>
            <span className={"govdash-statValue"}>{village?.VillageVoterCount?.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
